<template>
	<el-card id="info2">
		<div slot="header">详情页面 2/2</div>
		<div class="main clearfloat marginT20">
			<div class="templateBox left">
				<img class="phoneImg" :src="require('@/assets/imges/standard/airCleaner/airDetail2.png')" alt />
			</div>
			<!-- 箭头块 -->
			<div class="iconBox left">
				<i class="el-icon-right iconRight" style="margin-top: 66px"></i>
				<i class="el-icon-right iconRight" style="margin-top: 270px"></i>
			</div>
			<!-- 配置块 -->
			<div class="configBox left">
				<p class="title">按钮设计</p>
				<!-- 按钮列表 -->
				<div class="btnConfigList">
					<div class="btnConfigItem marginT10" v-for="(item, index) in btns" :key="index">
						<!-- 操作 -->
						<div class="btnConfigHeader clearfloat">
							<p class="inline" v-if='item.btnType == 1'>{{ "按钮" + (index + 1) }}</p>
							<p class="inline" v-if="item.btnType == 2">{{ "按钮" + (index + 1) }} (图标按钮)</p>
							<el-button
								class="right"
								size="mini"
								type="danger"
								icon="el-icon-delete"
								@click="handleDeleteBtn(index)"
							></el-button>
							<el-button
								class="right marginR10"
								size="mini"
								type="primary"
								icon="el-icon-top"
								:disabled="index == 0"
								@click="handleMove('up',index)"
							></el-button>
							<el-button
								class="right"
								size="mini"
								type="primary"
								icon="el-icon-bottom"
								:disabled="index == btns.length-1"
								@click="handleMove('down',index)"
							></el-button>
						</div>
						<!-- 配置 -->
						<div class="clearfloat marginT10" v-if='item.btnType == 1'>
							<!-- 激活图片 -->
							<el-tooltip class="item" effect="dark" content="激活图片" placement="top-start">
								<el-upload
									:ref="'active' + index"
									:show-file-list="false"
									:auto-upload="false"
									action="#"
									v-if="item.value != 0"
									class="btnConfigUpload"
									accept=".png"
									:limit="1"
									:on-change="
									(file, filesList) =>
										handleChoseFile(file, index, 'active')
								"
								>
									<i class="el-icon-plus btnImgIcon" v-if="!item.activeImage"></i>
									<img :src="item.activeImage" v-else class="btnImage" />
								</el-upload>
							</el-tooltip>
							<!-- 未激活图片 -->
							<el-tooltip class="item" effect="dark" content="未激活图片" placement="top-start">
								<el-upload
									:ref="'inactive' + index"
									:show-file-list="false"
									:auto-upload="false"
									action="#"
									v-if="item.value != 0"
									class="btnConfigUpload marginL10"
									accept=".png"
									:limit="1"
									:on-change="
									(file, filesList) =>
										handleChoseFile(file, index, 'inactive')
								"
								>
									<i class="el-icon-plus btnImgIcon" v-if="!item.inactiveImage"></i>
									<img :src="item.inactiveImage" v-else class="btnImage" />
								</el-upload>
							</el-tooltip>
							<!-- 名称 -->
							<el-tooltip class="item" effect="dark" content="功能名称" placement="top-start">
								<el-input placeholder="名称" size="small" class="btnConfigInput marginL10" v-model="item.name"></el-input>
							</el-tooltip>
							<!-- 辅助描述 -->
							<el-tooltip class="item" effect="dark" content="辅助描述" placement="top-start">
								<el-input placeholder="描述" size="small" class="btnConfigInput marginL10" v-model="item.desc"></el-input>
							</el-tooltip>
							<!-- 类型 -->
							<el-select
								v-model="item.type"
								size="small"
								class="btnConfigInput marginL10"
								@change="(val)=>handleChangeBtnType(index,val)"
							>
								<el-option
									v-for="type in btnTypes"
									:key="type.value"
									:value="type.value"
									:label="type.label"
								></el-option>
							</el-select>
							<!-- 页面 type == 2 -->
							<el-select
								v-model="item.secondImageId"
								v-if="item.type == 2"
								size="small"
								class="btnConfigInput marginL10"
								@change="
									(val) => {
										handleChangePageType(index, val);
									}
								"
							>
								<el-option
									v-for="page in pages"
									:key="page.id"
									:value="page.id"
									:label="handlePageName(page)"
								></el-option>
							</el-select>
							<!-- 属性 type == 1 -->
							<el-select
								v-model="item.propertyId"
								v-if="item.type == 1"
								size="small"
								class="btnConfigInput marginL10"
							>
								<el-option
									v-for="type in propertes"
									:key="type.id"
									:value="type.id"
									:label="type.propertyName"
								></el-option>
							</el-select>
							<!-- 外链 type == 3 -->
							<el-input
								size="small"
								class="longInput marginL10"
								v-model="item.linkUrl"
								v-if="item.type == 3"
							></el-input>
							<!-- 浮窗 type == 5 -->
							<el-select
								v-model="item.secondImageId"
								v-if="item.type == 5"
								size="small"
								class="btnConfigInput marginL10"
								@change="
									(val) => {
										handleChangePageType(index, val);
									}
								"
							>
								<el-option
									v-for="page in dialogComputedPages"
									:key="page.id"
									:value="page.id"
									:label="handlePageName(page)"
								></el-option>
							</el-select>
							<el-select
								v-model="item.propertyId"
								v-if="item.type == 5"
								size="small"
								class="btnConfigInput marginL10"
								@change="(val) => handlePropertyChange(val, index)"
							>
								<el-option
									v-for="type in propertes"
									:key="type.id"
									:value="type.id"
									:label="type.propertyName"
								></el-option>
							</el-select>
							<div style="display:inline-block;margin-top:8px;">
								<div v-for="(iconItem, i) in item.imageList" :key="i" style="margin-bottom: 8px;">
									<span class="enum-name">{{ iconItem.name }}</span>
									<!-- 激活图片 -->
									<!-- {{ iconItem }} -->
									<el-tooltip class="item" effect="dark" content="激活图片" placement="top-start">
										<el-upload
											:ref="'active' + index + 'btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile2(file, index, i, 'active')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.activeImage"></i>
											<img :src="iconItem.activeImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
									<!-- 未激活图片 -->
									<el-tooltip class="item" effect="dark" content="未激活图片" placement="top-start">
										<el-upload
											:ref="'inactive' + index + 'btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload marginL10"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile2(file, index, i, 'inactive')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.inactiveImage"></i>
											<img :src="iconItem.inactiveImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
								</div>
							</div>
						</div>
						<div class="clearfloat flex-box marginT10" v-if='item.btnType == 2'>
							<el-select
								v-model="item.propertyId"
								size="small"
								class="btnConfigInput marginL10"
								@change="(val) => handlePropertyChange(val, index)"
							>
								<el-option
									v-for="type in enumPropertes"
									:key="type.id"
									:value="type.id"
									:label="type.propertyName"
								></el-option>
							</el-select>
							<div style="display:inline-block;margin-left:24px;">
								<div v-for="(iconItem, i) in item.imageList" :key="i" style="margin-bottom: 8px;">
									<span class="enum-name">{{ iconItem.name }}</span>
									<!-- 激活图片 -->
									<!-- {{ iconItem }} -->
									<el-tooltip class="item" effect="dark" content="激活图片" placement="top-start">
										<el-upload
											:ref="'active' + index + 'btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile2(file, index, i, 'active')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.activeImage"></i>
											<img :src="iconItem.activeImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
									<!-- 未激活图片 -->
									<el-tooltip class="item" effect="dark" content="未激活图片" placement="top-start">
										<el-upload
											:ref="'inactive' + index + 'btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload marginL10"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile2(file, index, i, 'inactive')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.inactiveImage"></i>
											<img :src="iconItem.inactiveImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
								</div>

							</div>
						</div>
					</div>
					<el-button class="marginT20" size="mini" type="primary" @click="handleAddBtn">新增按钮</el-button>
					<el-button class="marginT20" size="mini" type="primary" @click="handleAddIconBtn">新增图标按钮</el-button>
				</div>
				<p class="title"  style="margin-top:24px;">开机状态按钮</p>
				<!-- 功能按钮 -->
				<div class="btnConfigList" style="margin-top:16px;">
					<div class="btnConfigItem marginT10" v-for="(item, index) in Bbtns" :key="index">
						<!-- 操作 -->
						<div class="btnConfigHeader clearfloat">
							<p class="inline" v-if='index === 0'>开关按钮</p>
							<p class="inline" v-else>{{ "开机状态卡片按钮" + (index + 1) }}</p>
							<el-button
								class="right"
								size="mini"
								type="danger"
								icon="el-icon-delete"
								@click="handleDeleteBtn1(index)"
							></el-button>
							<el-button
								class="right marginR10"
								size="mini"
								type="primary"
								icon="el-icon-top"
								:disabled="index == 0"
								@click="handleMove1('up',index)"
							></el-button>
							<el-button
								class="right"
								size="mini"
								type="primary"
								icon="el-icon-bottom"
								:disabled="index == Bbtns.length-1"
								@click="handleMove1('down',index)"
							></el-button>
						</div>
						<!-- 配置 -->
						<div class="clearfloat marginT10">
							<!-- 激活图片 -->
							<el-tooltip class="item" effect="dark" content="激活图片" placement="top-start">
								<el-upload
									:ref="'active' + index + 'Btn'"
									:show-file-list="false"
									:auto-upload="false"
									action="#"
									v-if="item.value != 0"
									class="btnConfigUpload"
									accept=".png"
									:limit="1"
									:on-change="
									(file, filesList) =>
										handleChoseFile1(file, index, 'active')
								"
								>
									<i class="el-icon-plus btnImgIcon" v-if="!item.activeImage"></i>
									<img :src="item.activeImage" v-else class="btnImage" />
								</el-upload>
							</el-tooltip>
							<!-- 未激活图片 -->
							<el-tooltip class="item" effect="dark" content="未激活图片" placement="top-start">
								<el-upload
									:ref="'inactive' + index + 'Btn'"
									:show-file-list="false"
									:auto-upload="false"
									action="#"
									v-if="item.value != 0"
									class="btnConfigUpload marginL10"
									accept=".png"
									:limit="1"
									:on-change="
									(file, filesList) =>
										handleChoseFile1(file, index, 'inactive')
								"
								>
									<i class="el-icon-plus btnImgIcon" v-if="!item.inactiveImage"></i>
									<img :src="item.inactiveImage" v-else class="btnImage" />
								</el-upload>
							</el-tooltip>
							<!-- 名称 -->
							<el-tooltip class="item" effect="dark" content="功能名称" placement="top-start">
								<el-input placeholder="名称" size="small" class="btnConfigInput marginL10" v-model="item.name"></el-input>
							</el-tooltip>
							<!-- 辅助描述 -->
							<el-tooltip class="item" effect="dark" content="辅助描述" placement="top-start">
								<el-input placeholder="描述" size="small" class="btnConfigInput marginL10" v-model="item.desc"></el-input>
							</el-tooltip>
							<!-- 类型 -->
							<el-select
								v-model="item.type"
								size="small"
								class="btnConfigInput marginL10"
								@change="(val)=>handleChangeBtnType1(index,val)"
							>
								<el-option
									v-for="type in btnTypes"
									:key="type.value"
									:value="type.value"
									:label="type.label"
								></el-option>
							</el-select>
							<!-- 页面 type == 2 -->
							<el-select
								v-model="item.secondImageId"
								v-if="item.type == 2"
								size="small"
								class="btnConfigInput marginL10"
								@change="
									(val) => {
										handleChangePageType1(index, val);
									}
								"
							>
								<el-option
									v-for="page in pages"
									:key="page.id"
									:value="page.id"
									:label="handlePageName(page)"
								></el-option>
							</el-select>
							<!-- 属性 type == 1 -->
							<el-select
								v-model="item.propertyId"
								v-if="item.type == 1"
								size="small"
								class="btnConfigInput marginL10"
							>
								<el-option
									v-for="type in propertes"
									:key="type.id"
									:value="type.id"
									:label="type.propertyName"
								></el-option>
							</el-select>
							<!-- 外链 type == 3 -->
							<el-input
								size="small"
								class="longInput marginL10"
								v-model="item.linkUrl"
								v-if="item.type == 3"
							></el-input>
							<!-- 浮窗 type == 5 -->
							<el-select
								v-model="item.secondImageId"
								v-if="item.type == 5"
								size="small"
								class="btnConfigInput marginL10"
								@change="
									(val) => {
										handleChangePageType1(index, val);
									}
								"
							>
								<el-option
									v-for="page in dialogComputedPages"
									:key="page.id"
									:value="page.id"
									:label="handlePageName(page)"
								></el-option>
							</el-select>
							<el-select
								v-model="item.propertyId"
								v-if="item.type == 5"
								size="small"
								class="btnConfigInput marginL10"
								@change="(val) => handlePropertyChange1(val, index)"
							>
								<el-option
									v-for="type in propertes"
									:key="type.id"
									:value="type.id"
									:label="type.propertyName"
								></el-option>
							</el-select>
							<div style="display:inline-block;margin-top:8px;">
								<div v-for="(iconItem, i) in item.imageList" :key="i" style="margin-bottom: 8px;">
									<span class="enum-name">{{ iconItem.name }}</span>
									<!-- 激活图片 -->
									<!-- {{ iconItem }} -->
									<el-tooltip class="item" effect="dark" content="激活图片" placement="top-start">
										<el-upload
											:ref="'active' + index + 'Btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile3(file, index, i, 'active')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.activeImage"></i>
											<img :src="iconItem.activeImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
									<!-- 未激活图片 -->
									<el-tooltip class="item" effect="dark" content="未激活图片" placement="top-start">
										<el-upload
											:ref="'inactive' + index + 'Btns' + i"
											:show-file-list="false"
											:auto-upload="false"
											action="#"
											class="btnConfigUpload marginL10"
											accept=".png"
											:limit="1"
											:on-change="
											(file, filesList) =>
												handleChoseFile3(file, index, i, 'inactive')
										"
										>
											<i class="el-icon-plus btnImgIcon" v-if="!iconItem.inactiveImage"></i>
											<img :src="iconItem.inactiveImage" v-else class="btnImage" />
										</el-upload>
									</el-tooltip>
								</div>
							</div>
						</div>
					</div>
					<el-button class="block marginT20" size="mini" type="primary" @click="handleAddBtn1">新增按钮</el-button>
				</div>
			</div>
			<!-- {{ btns }} -->
		</div>
	</el-card>
</template>

<script>
export default {
	name: "info2",
	props: ["productId", "infoData", "pages", "propertes"],
	watch: {
		infoData: {
			deep: true,
			handler(val) {
				if (val.funcAreaAList && val.funcAreaAList.length > 0) {
					this.btns = this.$utils.deepClone(val.funcAreaAList);
					this.Bbtns = this.$utils.deepClone(val.funcAreaBList);
				}
			},
		},
	},
	data() {
		return {
			btns: [
				{
					btnType: 1,
					name: "",
					type: "",
					propertyId: "", // 属性ID
					activeImage: "", // 激活图片
					inactiveImage: "", // 未激活图片
					secondImageId: "", // 页面Id
					pageType: "", // 页面类型
					linkUrl: "", // 外链
					desc: "", // 辅助描述,
					imageList: [],
				},
			],
			Bbtns: [
				{
					btnType: 2,
					name: "",
					type: "",
					propertyId: "", // 属性ID
					activeImage: "", // 激活图片
					inactiveImage: "", // 未激活图片
					secondImageId: "", // 页面Id
					pageType: "", // 页面类型
					linkUrl: "", // 外链
					desc: "", // 辅助描述
					imageList: [],
				}
			],
			workingStates: [],
			statusList: [],
			btnTypes: [
				{
					value: 1,
					label: "属性",
				},
				{
					value: 2,
					label: "页面",
				},
				{
					value: 3,
					label: "外链",
				},
				{
					value: 5,
					label: "弹窗",
				},
			],
		};
	},
	mounted() {
		this.getWorkStates();
	},
	computed: {
		// 图标按钮只有能选择枚举类
		enumPropertes() {
			return this.propertes.filter((el) => {
				return el.type == 5
			})
		},
		dialogComputedPages() {
			return this.pages.filter((el) => {
				// 22 模式选择，23 定时, 24 浮窗
				return el.type == 22 || el.type == 23 || el.type == 24
			})
		},
	},
	methods: {
		handlePropertyChange(val, index) {
			let tem = this.enumPropertes.filter(el => el.id == val)[0]
			let imageList = []
			if (tem) {
				let bounds = {}
				try {
					bounds = JSON.parse(tem.bounds).items
				} catch {}
				if (bounds) {
					for (let key in bounds) {
						imageList.push({
							code: key,
							name: bounds[key],
							activeImage: '',
							inactiveImage: '',
						})
					}
				}
			}
			this.btns[index].imageList = imageList
		},
		handlePropertyChange1(val, index) {
			let tem = this.enumPropertes.filter(el => el.id == val)[0]
			let imageList = []
			if (tem) {
				let bounds = {}
				try {
					bounds = JSON.parse(tem.bounds).items
				} catch {}
				if (bounds) {
					for (let key in bounds) {
						imageList.push({
							code: key,
							name: bounds[key],
							activeImage: '',
							inactiveImage: '',
						})
					}
				}
			}
			this.Bbtns[index].imageList = imageList
		},
		// 获取工作模式
		getWorkStates: function () {
			this.$http.productWorkModels(this.productId).then((res) => {
				if (res.data.success) {
					let bounds = JSON.parse(res.data.data.bounds).items;
					for (let i in bounds) {
						this.workingStates.push({
							value: Number(i),
							label: bounds[i],
						});
					}
				}
			});
		},
		// 删除Btn
		handleDeleteBtn: function (index) {
			let list = Object.assign([], this.btns);
			list.splice(index, 1);
			this.$set(this, "btns", list);
		},
		// 删除Btn
		handleDeleteBtn1: function (index) {
			let list = Object.assign([], this.Bbtns);
			list.splice(index, 1);
			this.$set(this, "Bbtns", list);
		},
		// 添加Btn
		handleAddBtn: function () {
			this.btns.push({
				btnType: 1,
				name: "",
				type: "",
				propertyId: "", // 属性ID
				activeImage: "", // icon图片
				inactiveImage: "", // icon图片
				secondImageId: "", // 页面Id
				pageType: "", // 页面类型
				linkUrl: "", // 外链
				desc: "", // 辅助描述
			});
		},
		// 添加Btn
		handleAddIconBtn: function () {
			this.btns.push({
				btnType: 2,
				name: "",
				type: 1,
				propertyId: "", // 属性ID
				activeImage: "", // icon图片
				inactiveImage: "", // icon图片
				secondImageId: "", // 页面Id
				pageType: "", // 页面类型
				linkUrl: "", // 外链
				desc: "", // 辅助描述
				imageList: [],
			});
		},
		// 添加Btn
		handleAddBtn1: function () {
			this.Bbtns.push({
				name: "",
				type: "",
				propertyId: "", // 属性ID
				activeImage: "", // icon图片
				inactiveImage: "", // icon图片
				secondImageId: "", // 页面Id
				pageType: "", // 页面类型
				linkUrl: "", // 外链
				desc: "", // 辅助描述
				imageList: []
			});
		},
		// 修改按钮指向页面时
		handleChangePageType: function (index, val) {
			for (let i in this.pages) {
				if (this.pages[i].id == val) {
					this.btns[index].pageType = this.pages[i].type;
				}
			}
		},
		// 修改按钮指向页面时-功能设计
		handleChangePageType1 (index, val) {
			for (let i in this.pages) {
				if (this.pages[i].id == val) {
					this.Bbtns[index].pageType = this.pages[i].type;
				}
			}
		},
		// 当修改页面类型时
		handleChangeBtnType: function (idx, val) {
			let list = Object.assign([], this.btns);
			list[idx].secondImageId = "";
			list[idx].propertyId = "";
			list[idx].linkUrl = "";
			this.$set(this, "btns", list);
		},
		// 当修改页面类型时-功能设计
		handleChangeBtnType1 (idx, val) {
			let list = Object.assign([], this.Bbtns);
			list[idx].secondImageId = "";
			list[idx].propertyId = "";
			list[idx].linkUrl = "";
			this.$set(this, "Bbtns", list);
		},
		// 移动按钮
		handleMove: function (fun, idx) {
			let list = this.$utils.handleMoveArr(this.btns, fun, idx);
			this.$set(this, "btns", list);
		},
		// 移动按钮
		handleMove1: function (fun, idx) {
			let list = this.$utils.handleMoveArr(this.Bbtns, fun, idx);
			this.$set(this, "Bbtns", list);
		},
		// 提交表单
		handleSubmit: function () {
			return {
				funcAreaAList: this.btns,
				funcAreaBList: this.Bbtns,
			};
		},
		// 选择图片
		handleChoseFile: function (file, index, name) {
			let _this = this,
				reader = new FileReader(),
				image = new Image(),
				base64 = null,
				list = Object.assign([], this.btns);
				console.log(list)
			image.onload = function () {
				// if (image.width != 192 || image.height != 192) {
					// 	Message.error("图片尺寸错误");
				// 	_this.$refs[name + index][0].clearFiles();
				// } else {
					list[index][name + "Image"] = base64;
				// _this.$set(this, "btns", list);
				console.log(list)
				_this.$refs[name + index][0].clearFiles();
				// }
			};
			reader.onload = function (e) {
				base64 = e.target.result;
				image.src = base64;
			};
			reader.readAsDataURL(file.raw);
		},
		// 选择图片 - 功能设计
		handleChoseFile1 (file, index, name) {
			let _this = this,
				reader = new FileReader(),
				image = new Image(),
				base64 = null,
				list = Object.assign([], this.Bbtns);
			image.onload = function () {
				// if (image.width != 192 || image.height != 192) {
				// 	Message.error("图片尺寸错误");
				// 	_this.$refs[name + index][0].clearFiles();
				// } else {
				list[index][name + "Image"] = base64;
				_this.$set(this, "Bbtns", list);
				_this.$refs[name + index + 'Btn'][0].clearFiles();
				// }
			};
			reader.onload = function (e) {
				base64 = e.target.result;
				image.src = base64;
			};
			reader.readAsDataURL(file.raw);
		},
		// 枚举值选择图片
		handleChoseFile2 (file, index, i, name) {
			let _this = this,
				reader = new FileReader(),
				image = new Image(),
				base64 = null,
				list = Object.assign([], this.btns);
			image.onload = function () {
				// if (image.width != 192 || image.height != 192) {
				// 	Message.error("图片尺寸错误");
				// 	_this.$refs[name + index][0].clearFiles();
				// } else {
				list[index].imageList[i][name + "Image"] = base64;
				_this.$set(this, "btns", list);
				_this.$refs[name + index + 'btns' + i][0].clearFiles();
				// }
			};
			reader.onload = function (e) {
				base64 = e.target.result;
				image.src = base64;
			};
			reader.readAsDataURL(file.raw);
		},
		handleChoseFile3 (file, index, i, name) {
			let _this = this,
				reader = new FileReader(),
				image = new Image(),
				base64 = null,
				list = Object.assign([], this.Bbtns);
			image.onload = function () {
				// if (image.width != 192 || image.height != 192) {
				// 	Message.error("图片尺寸错误");
				// 	_this.$refs[name + index][0].clearFiles();
				// } else {
				list[index].imageList[i][name + "Image"] = base64;
				_this.$set(this, "Bbtns", list);
				_this.$refs[name + index + 'Btns' + i][0].clearFiles();
				// }
			};
			reader.onload = function (e) {
				base64 = e.target.result;
				image.src = base64;
			};
			reader.readAsDataURL(file.raw);
		},
		// 转译页面名称
		handlePageName: function (page) {
			let type = this.$utils.escapePageName(page.type),
				nvgName = page.nvgName;
			if (page.inner) {
				return type;
			} else {
				return nvgName + "-" + type;
			}
		},
	},
};
</script>

<style scoped>
#info2 {
	min-width: 1200px;
}
.templateBox {
	width: 280px;
}
.iconRight {
	display: block;
	font-size: 28px;
}

.title {
	font-weight: 500;
	font-size: 14px;
}
.phoneImg {
	width: 280px;
	height: 600px;
}
.configBox {
	border: 1px solid #ccc;
	border-radius: 5px;
	padding: 20px;
	min-height: 478px;
	min-width: 760px;
}
.btnConfigList {
	margin-top: 16px;
}
.btnConfigHeader {
	height: 28px;
	line-height: 28px;
	vertical-align: bottom;
	font-size: 14px;
}
.btnConfigUpload {
	display: inline-block;
	vertical-align: bottom;
	width: 28px;
	height: 28px;
	border: 1px dashed #d9d9d9;
}
.btnConfigUpload:hover {
	border-color: #409eff;
}
.btnConfigInput {
	width: 150px;
}

.longInput {
	width: 250px;
}
.iconImg {
	float: right;
	width: 40px;
	height: 40px;
}
.btnImage {
	vertical-align: bottom;
	width: 28px;
	height: 28px;
}
.btnImgIcon {
	width: 28px;
	height: 28px;
	line-height: 28px;
}
.flex-box {
	display: flex;
	align-items: flex-start;
}
.enum-name {
	display: inline-block;
	margin-left: 8px;
	width: 120px;
}
</style>